module.exports = __webpack_public_path__ + "static/entertailer-034f30c859771e07fd16587b2f76291b.png";